import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';
import { useParams } from 'react-router-dom';
import classnames from 'classnames';

// Material
import ArrowBack from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';

// Style
import { withStyles } from '@material-ui/core/styles';

const styles = theme => {
  return {
    button: {
      marginRight: theme.spacing(),
    },
    icon: {
      color: theme.palette.text.primary,
      '&:hover': {
        color: theme.palette.secondary.A100,
      },
    },
  };
};

function BackButton({ classes, buttonClassName, iconClassName, goBack, query }) {
  const history = useHistory();

  const handleOnClick = () => {
    if (goBack) {
      history.goBack();
    } else {
      let { url } = useParams();
      let routes = url.split('/');
      routes.shift();

      let routeHref = '';
      // routes.length - 2 represents all routes except for the last one
      for (let i = 0; i <= routes.length - 2; i++) {
        routeHref = routeHref + '/' + routes[i];
      }

      history.push({
        pathname: routeHref,
        query: query,
      });
    }
  };

  return (
    <IconButton className={classnames(classes.button, buttonClassName)} onClick={handleOnClick}>
      <ArrowBack className={classnames(classes.icon, iconClassName)} key="backbutton" />
    </IconButton>
  );
}

BackButton.propTypes = {
  query: PropTypes.object,
  goBack: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  buttonClassName: PropTypes.string,
  iconClassName: PropTypes.string,
};

BackButton.skpName = 'PageBackButton';

export default withStyles(styles)(BackButton);
